export const list = (
  dispatch,
  apiClient,
  query,
  ids,
  fromDate,
  toDate,
  skipId
) => apiClient
  .call({
    endpoint: 'transaction/list',
    data: {
      query,
      ...ids,
      fromDate,
      toDate,
      skipId,
    }
  })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'TRANSACTIONS_SET', payload: res.data.results });
    return res;
  });

export const get = (dispatch, apiClient, id) => apiClient
  .call({ endpoint: 'transaction/get', data: { id } })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'TRANSACTIONS_SET', payload: res.data.transaction });
    return res;
  });



// WEBPACK FOOTER //
// ./app/actions/transactions.js